
import './defect-observation-view.scss'

import { FormApi } from 'final-form';
import Component from 'vue-class-component';

import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { DefectObservation } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { DeleteValidationOverlay, ThesaurusTermChooser } from '@skinsoft/ui';

import { Watch } from 'vue-property-decorator';
import { DefectMaterialView } from '../defect-material-view';

@Component({
    components: {
        sDefectMaterialView: DefectMaterialView,
        sDeleteValidationOverlay: DeleteValidationOverlay,
        sThesaurusTermChooser: ThesaurusTermChooser,
    },
    props: ['defectObservation', 'observationIndex', 'form', 'fieldName', 'elementName', 'deletable'],
    template: require('./defect-observation-view.html')
})
export class DefectObservationView extends ReactiveVue {

    public defectObservation: DefectObservation;
    public observationIndex: number;
    public form: FormApi;
    public currentTypeOfObsTermId: string = "";
    public fieldName: string;
    public elementName: string;
    public deletable: boolean;

    // Icons
    private plusIcon = faPlusCircle;
    private deleteIcon = faTrash;

    private displayDeleteOverlay: boolean = false;

    // used to generate an id for v-for feature (v-bind:key)
    private lastId = 1;

    public created() {
        this.$on('delete-material', (message) => {
            this.defectObservation.materialAlterations.splice(message.materialIndex, 1)
        })

        this.$on('field-value-changed', (message) => {
            this.currentTypeOfObsTermId = message.value;
        })

        // Catching delete-overlay events
        this.$on('deletion-validated-topic', this.deleteObservation)
        this.$on('deletion-canceled-topic', this.toggleOverlay)
    }

    public get typeOfObservationFieldName() {
        return `${this.fieldName}.typeOfObservation`
    }

    public materialFieldName(index) {
        return `${this.fieldName}.materialAlterations[${index}`
    }

    public createMaterial() {
        if (!this.defectObservation.materialAlterations) {
            this.defectObservation.materialAlterations = []
        }
        this.defectObservation.materialAlterations.push(
            {
                alterations: [],
                id: this.lastId++,
                material: ""
            }
        )
    }

    public deleteObservation() {
        this.$parent.$emit('delete-observation', { observationIndex: this.observationIndex })
    }

    public toggleOverlay() {
        this.displayDeleteOverlay = !this.displayDeleteOverlay
    }

    @Watch('defectObservation', { immediate: true, deep: true })
    public onDefectObservationChange() {
        this.currentTypeOfObsTermId = this.defectObservation.typeOfObservation
        this.displayDeleteOverlay = false;
    }

}